export const PleasantHolidaysUrl = () => {
    return 'https://www.pleasantholidays.com/Hawaii-Vacation-Package-Deals';
};
